// Server API URL
export const API_URL = 'https://po-api.austere.biz' 

// Server PDF_API_URL
export const PDF_API_URL = 'https://pdf.austere.biz'

// Local API URL
// export const API_URL = 'http://localhost:8000' 

// // Local PDF_API_URL
// export const PDF_API_URL = 'http://localhost:8005'
